import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/UI/Button';
export const BibiEnejeSpotlight = () => {
  return <div className="pt-20 bg-white min-h-screen" data-id="element-2498" data-mp="33x5r3d0z1bn3">
      <section className="relative py-16 border-b border-gray-200" data-id="element-2499" data-mp="33ygsx7auw9bk">
        <div className="absolute inset-0 z-0" data-id="element-2500" data-mp="38ws2ri15ijts">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iAnbjCZ3t34HT1XWLnohD6/Bibi_Eneje_The_Networking_Salon_Spotlight.png" alt="Bibi Eneje" className="w-full h-full object-cover grayscale" loading="lazy" data-id="element-2501" data-mp="38xjzwxaecpm6" />
          <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-2502" data-mp="3mv8btfmhkmf3"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2503" data-mp="3rt0d3090tkvy">
          <div className="max-w-4xl mx-auto" data-id="element-2504" data-mp="je9linsgc1s6">
            <Link to="/salon-spotlight" className="inline-flex items-center text-white hover:text-gray-200 mb-6" data-id="element-2505" data-mp="jdgpohv16wot">
              <ArrowLeft size={20} className="mr-2" data-id="element-2506" data-mp="2fpuinakcryh7" />
              Back to Salon Spotlight
            </Link>
            <div className="text-white" data-id="element-2507" data-mp="2aslyx5jk3mdu">
              <p className="text-sm mb-4" data-id="element-2508" data-mp="2apga7reuamin">SALON SPOTLIGHT</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-2509" data-mp="2phid7kc7hvmw">
                Bibi Eneje
              </h1>
              <p className="text-2xl md:text-3xl font-medium" data-id="element-2510" data-mp="2kofih8vp0g54">
                Architect of Influence. Builder of Ecosystems. Champion of
                Clarity.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-2511" data-mp="38f1eg1sfa9yr">
        <div className="container mx-auto px-4" data-id="element-2512" data-mp="38e045zj8dri3">
          <div className="max-w-4xl mx-auto" data-id="element-2513" data-mp="33g8c95il65dw">
            <article className="prose prose-lg max-w-none" data-id="element-2514" data-mp="33hjgf6fy1f5j">
              <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-2515" data-mp="1e10h5lcitv0s">
                Every community has people whose presence doesn't just add
                energy—they elevate the room. In The Networking Salon, Bibi
                Eneje is one of those rare catalysts. An entrepreneur,
                communications advisor, and nation builder, Bibi moves through
                the world with a quiet intensity that turns ideas into structure
                and vision into cultural momentum.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2516" data-mp="2cqdtewhj246j">
                As Founder and Lead Strategist at Kora & Hive Communications,
                she designs influence with intention—helping African leaders
                show up with clarity, credibility, and confidence. Through The
                Work Haven, she curates spaces where creators and founders meet,
                collaborate, and grow, building ecosystems that strengthen the
                fabric of innovation across the continent. She mentors at
                Morpheus Academy, co-leads community projects like The Table and
                RETRO, and continues to shape culture through the rooms she
                creates and the people she empowers.
              </p>
              <div className="my-12" data-id="element-2517" data-mp="tp3a1kb5k5wr">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a1cmPsUKCWVvANEm2rKKvj/IMG_6994.png" alt="Bibi Eneje portrait" className="w-full max-w-2xl mx-auto rounded-lg border-2 border-gray-300" loading="lazy" data-id="element-2518" data-mp="os391nt5ttci" />
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2519" data-mp="1ch5pwtfyzi5y">
                Her Story: A Calling Shaped by Storytelling
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2520" data-mp="12rmajxrgu6fu">
                Bibi's journey began with a simple truth: stories shape what
                people believe is possible. Starting out as a features writer,
                she discovered that the most powerful ideas often lacked
                visibility. Her work became a way of correcting that
                imbalance—giving voice to remarkable projects and the people
                behind them.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2521" data-mp="1fyigo2dvlzal">
                At Kora & Hive, she builds communication systems that earn
                trust. At The Work Haven, she and her team crafted a space where
                creators don't just work—they grow. Behind it all is her mission
                to help people find their voice and give that voice room to
                build something real.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2522" data-mp="1ynygenhqlnpy">
                Culture, Community, and Impact
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2523" data-mp="1jyj246ze7ar5">
                Bibi believes culture is shaped in the rooms where people feel
                seen, heard, and understood. Her work—whether through curated
                communities, storytelling systems, or intentional
                teaching—creates those rooms.
              </p>
              <div className="my-12" data-id="element-2524" data-mp="5zqsco51p9ci">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cVfpQEfSVn8mT6V81pCzxx/IMG_6996.png" alt="Bibi Eneje" className="w-full max-w-2xl mx-auto rounded-lg border-2 border-gray-300" loading="lazy" data-id="element-2525" data-mp="5ypde8kws2pi" />
              </div>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2526" data-mp="3j7289mlr4dcf">
                The Work Haven thrives on community, collaboration, and growth.
                The Table nurtures a network of publicists raising the standard
                for communication across Africa. RETRO invites women to lead
                boldly, reminding them that influence expands when we do.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2527" data-mp="17hrlcrsip4w7">
                Her north star is simple: help people think clearer, act braver,
                and lead with confidence. Every piece of feedback, every shift
                in someone's clarity or courage, reassures her that the work
                matters.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2528" data-mp="5320nsk394mu">
                What She's Building Next
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2529" data-mp="a1lpq1tzawjf">
                Bibi is drawn to collaborations at the intersection of
                storytelling, culture, and national impact. She is open to
                projects with cultural institutions, tourism boards, and
                development organizations shaping perception and policy across
                Africa. Editorial and thought-leadership collaborations also sit
                at the top of her creative pursuits.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2530" data-mp="2utnhuephw4iu">
                Her influences are leaders who turn authority into
                participation—those who see power as something to circulate. And
                her advice to young builders is a gentle but firm compass: Start
                with clarity. Learn your craft deeply. Build slowly and in
                community. And when you rise, make room for others.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2531" data-mp="2i9i5ca4gonpf">
                Why We Celebrate Her
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2532" data-mp="2deb6pgq1u97d">
                In The Networking Salon, Bibi has been a strategic
                ally—supportive, present, thoughtful, and deeply invested in
                growth. She embodies the spirit of this ecosystem: intentional
                connection, generous service, and leadership that multiplies
                opportunity.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed font-medium italic border-l-4 border-gray-300 pl-6 my-12" data-id="element-2533" data-mp="1pme66ls1v3lk">
                Bibi, thank you for shaping culture with clarity, courage, and
                heart. Your work reminds us that influence is not loud—it is
                deeply understood.
              </p>
            </article>
            <div className="mt-16 pt-8 border-t-2 border-gray-300" data-id="element-2534" data-mp="3dik4eohxsck6">
              <Link to="/salon-spotlight" data-id="element-2535" data-mp="2zk3yv0vt8s3m">
                <Button variant="outline" data-id="element-2536" data-mp="2zj15mmb0mdkj">
                  <ArrowLeft size={20} className="mr-2" data-id="element-2537" data-mp="34hw0imm9bsl0" />
                  Back to Salon Spotlight
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};